import React from "react";
import PageHero from "../components/shared/PageHero";
import PolicySection from "../components/legal/PolicySection";
import ContactPromptCard from "../components/legal/ContactPromptCard";

export default function Privacy() {
  return (
    <>
      <PageHero
        eyebrow="FAQ"
        title="Frequently Asked Questions"
        subtitle="Questions about services, partnerships, or your account? Reach out and our team will get back to you."
      />

      <section className="mu-section pb-4">
        <div className="container">
          <PolicySection
            title="Privacy Policy"
            paragraphs={[
              "MusicUntamed collects only the information needed to run your account, distribute your music, and process payouts — things like your name, email, artist details, and payment information.",
              "We never sell your personal information to third parties. Data is shared only with the streaming platforms and partners required to deliver the services you sign up for, such as distributing a release or processing a royalty payment.",
              "You can review, update, or request deletion of your personal information at any time from your account settings, or by reaching out to our support team using the form below.",
              "We use industry-standard security practices to protect your data, including encrypted storage and restricted internal access. If our privacy practices ever change in a way that affects you, we'll let you know before the change takes effect."
            ]}
          />
        </div>
      </section>

      <ContactPromptCard />
    </>
  );
}
